import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";
import { useQuery } from "@tanstack/react-query";

import { queries } from "./factories";

export const useUserEventsQuery = ({
  queryBuilder,
}: {
  queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
}) => {
  return useQuery(queries.list({ queryBuilder }));
};

export const useActivityQuery = (id: string | undefined) => {
  return useQuery({
    ...queries.detail(id ?? ""),
    enabled: !!id,
    // A 404 is an expected outcome here (a shared link to an event past the
    // 30-day retention window), so don't burn retries with backoff before
    // surfacing the error.
    retry: false,
  });
};
